export default __webpack_public_path__ + "static/media/image.insel-global-holdings-pvt-ltd.e3db11a4.png";